import { Header } from "./components/Header";
import { AllRoutes } from "./routes/AllRoutes";

function App() {
  return (
    <div>
      <Header />
      <AllRoutes />
    </div>
  );
}

export default App;
